import { AxiosError, AxiosResponse } from "axios";
import { SelectOption } from "../../components/UI/Inputs/InputSelect";
import { moduleToSelectOptions, refactorAttributes } from "../../components/Vehicles/FindVehicleFilter/utils";
import { EquipmentType } from "../../components/Vehicles/SingleVehicle/VehicleSpecs/Equipment";
import { HighlightsType } from "../../components/Vehicles/SingleVehicle/VehicleSpecs/Highlights";
import {
  assignAttributesToSellVehicle,
  deleteImagesFromVehicle,
  getAllVehicleCategories,
  // getAttributesFor,
  getCities,
  // getModelsFor,
  getRegions,
  getSingleVehicle,
  getVehicleCategories,
  // getUsedBrandsFor,
  removeAttributesFomSellVehicle,
  sellVehicle,
  updateAttributesToSellVehicle,
  updatedSoldVehicle,
  uploadImagesToSellVehicle,
} from "../../utils/fetcher";
import { AttributesOption, VehicleTypesT } from "../../utils/GeneralTypes";
import { compressImage } from "../../utils/compress";
import { RulesLogic } from "json-logic-js";

export type dataStateType = {
  brands: SelectOption[];
  brandsDependants: any[];
  models: SelectOption[];
  modelsDependants: any[];
  modelYears: SelectOption[];
  cities: SelectOption[];
  citiesDependants: any[];
  regions: SelectOption[];
  attributes: AttributesOption[];
  categories_0: SelectOption[];
  categories_0Dependants: any[];
  // categories_1: SelectOption[];
  // categories_1Dependants: any[];
  categories: SelectOption[];
  editingVehicle: any;
};

export type stateType = {
  isFetching: boolean;
  data: dataStateType;
  activePage: number;
};

export type previewDataState = {
  attributes: {
    equipments: AttributesOption[];
    highlights: AttributesOption[];
  };
  details: string;
  price: number;
  images: string[];
  model: {
    name: string;
    year: string;
    brand: {
      name: string;
    };
  };
};

export const defaultValues: any = {
  brand: "no_option",
  brand_model: "no_option",
  model_id: "no_option",
  price: "",
  rentable: false,
  rent: "",
  milage: "",
  city: "no_option",
  region_id: "no_option",
  description: "",
  images: [],
  attributes: {},
  name: "",
  phone: "",
  email: "",
  license_id: "",
  category_0: "no_option",
  // category_1: "no_option",
  category: "no_option",
};

/**
 * `fetchVehicleData` used to fetch data for selling process(categorires/brands/models/....)
 *
 * if vehicle id is provided vehicle data will fetched too
 */
export async function fetchVehicleData(
  vehicleType: VehicleTypesT,
  isEditing: boolean,
  vehicleID: string | null,
  vehicleCondition: "used",
) {
  let data: dataStateType = {
    brands: [],
    brandsDependants: [],
    models: [],
    modelsDependants: [],
    modelYears: [],
    cities: [],
    citiesDependants: [],
    regions: [],
    attributes: [],
    categories_0: [],
    categories_0Dependants: [],
    // categories_1: [],
    // categories_1Dependants: [],
    categories: [],
    editingVehicle: null,
  };
  const allFetchers: Promise<AxiosResponse<any>>[] = [
    getCities(),
    getRegions(),
    // TODO: enable for vehicles without categories
    // ...(vehicle !== "truck"
    //   ? [getUsedBrandsFor(vehicle), getModelsFor(vehicle), getAttributesFor(`${vehicle}?condition=${type}`)]
    //   : []),
    getAllVehicleCategories(vehicleType, { condition_code: vehicleCondition }),
    ...(isEditing && vehicleID ? [getSingleVehicle(vehicleType, "used", +vehicleID)] : []),
  ];
  const res = await Promise.all(allFetchers);
  // let brands: any;
  // TODO: enable for vehicles without categories
  // if (vehicleType !== "truck") {
  //   brands = moduleToSelectOptions(res[2].data.brands, [["name", ""], "id", "logo"], ["brand_model", "model_id"]);
  //   data.brands = brands.options;
  //   data.brandsDependants = brands.dependantConditions;
  //   const models = moduleToSelectOptions(
  //     res[3].data.models,
  //     [["name", ""], "id", "image"],
  //     ["model_id"],
  //     ["brand"],
  //     true,
  //     "or",
  //   );
  //   data.models = models.options;
  //   data.modelsDependants = models.dependantConditions!;
  //   data.modelYears = models.years!;
  // }
  // if (vehicleType !== "truck") {
  //   data.attributes = refactorAttributes(res[4].data.attributes);
  // }
  const cities = moduleToSelectOptions(res[0].data.cities, [["name", ""], "id", ""], ["region_id"]);
  data.cities = cities.options;
  data.citiesDependants = cities.dependantConditions!;
  data.regions = moduleToSelectOptions(res[1].data.regions, [["name", ""], "id", ""], null, ["city"]).options;
  // if (vehicleType === "truck") {
  const categoriesOptions = vehicleCategoriesOptions(res[2].data.categories);
  data.categories_0 = categoriesOptions.categories0;
  data.categories_0Dependants = categoriesOptions.categories0DependantConditions;
  // data.categories_1 = truckCatsData.categories1;
  // data.categories_1Dependants = truckCatsData.categories1DependantConditions;
  data.brands = categoriesOptions.brands;
  data.brandsDependants = categoriesOptions.brandsDependantsConditions;
  data.models = categoriesOptions.models;
  data.attributes = categoriesOptions.attributes;
  data.modelYears = categoriesOptions.modelYears;
  // }
  if (isEditing) {
    data.editingVehicle = {
      ...res[res.length - 1].data?.vehicle,
      attributes: res[res.length - 1].data?.vehicle.attributes,
    };
  }
  return data;
}

/**
 * get data to be showen as preview(don't handle the rendering)
 */
export function previewVehicleBeforeSubmit(
  allData: dataStateType,
  submittedData: any,
  siteLang: "en" | "ar",
  isEditing: boolean,
  defaultImages: string[],
) {
  const searchAttr = (id: any, value: any) => {
    let attr = allData?.attributes?.find((each) => each.id == id);
    let label = attr?.values?.find((each) => each?.value == value)?.name;
    return label;
  };
  //attributes
  const attributes: {
    equipments: EquipmentType[];
    highlights: HighlightsType[];
  } = {
    equipments: [],
    highlights: [],
  };
  // submittedData.attributes only holds the user choosen values for the attribute
  const submittedAttributes = submittedData.attributes as { [k: string]: string | boolean | undefined };
  Object.entries(submittedAttributes).forEach((entry) => {
    const oneAttribute = allData.attributes.find((el) => +el.id === +entry[0]);
    if (!oneAttribute) throw new Error("how did we set value for attribute that doesn't exist");
    if (entry[1] === true) {
      attributes.equipments.push({
        id: +oneAttribute.id,
        icon: oneAttribute.image || "",
        name: oneAttribute.name,
        value: "",
      });
    } else if (entry[1] && entry[1] !== "" && entry[1] !== "no_option") {
      attributes.highlights.push({
        id: +oneAttribute.id,
        icon: oneAttribute.image || "",
        name: oneAttribute.name,
        label: searchAttr(entry[0], entry[1]),
        value: entry[1],
      });
    }
  });

  return {
    attributes,
    details: submittedData[`description_${siteLang}`],
    price: submittedData.price,
    rent: submittedData.rent,
    description: submittedData.description,
    region_id: submittedData.region_id,
    city: submittedData.city,
    images: (submittedData.images ?? []).map((file: { id: number; file: File | string }) => {
      return file.file instanceof File ? window.URL.createObjectURL(file.file) : file.file;
    }),
    created_at: new Date().toISOString(),
    mileage: submittedData.milage,
    seller: {
      name: submittedData.name,
      email: submittedData.email,
      phone: submittedData.phone,
    },
    model: {
      //name: submittedData.brand_model,
      name: allData.models.find((el) => +el.value === +submittedData.brand_model)?.label,
      year: allData.modelYears.find((el) => +el.value === +submittedData.model_id)?.label,
      brand: {
        name: allData.brands.find((el) => +el.value === +submittedData.brand)?.label,
      },
    },
  };
}

function insertValueIntoFormData(v: unknown): string {
  if (v === null || v === undefined) return "";
  if (typeof v === "boolean" && v === true) {
    return "1";
  }
  if (typeof v === "boolean" && v === false) {
    return "0";
  }
  return v as string;
}

export const submitToSellVehicle = async (
  vehicleType: VehicleTypesT,
  // TODO: add type to this
  data: any,
  isEditing: boolean,
  vehicleID: string | null,
  deletedImages: number[],
  // TODO: add type to this
  defaultAttributes: any,
  rawAttributes: AttributesOption[],
) => {
  const submittedData = new FormData();

  Object.keys(data).forEach((key) => {
    if (key !== "description" && key !== "attributes" && key !== "images" && !key.includes("category")) {
      if (key === "milage") {
        submittedData.append(key, insertValueIntoFormData(data[key]));
      } else submittedData.append(key, insertValueIntoFormData(data[key]));
    }
  });

  if (vehicleType === "bus") {
    if (!submittedData.get("rent")) {
      submittedData.delete("rent");
    }
  }

  // if (vehicleType === "truck" && (!data.category || data.category === "no_option"))
  //   data.category = data.category_1;

  submittedData.append("category_id", data.category_0 ?? data.category);

  if (data.description) {
    submittedData.append("description_en", data.description);
    submittedData.append("description_ar", data.description);
  }

  const vehicleImages = await Promise.all(
    ((data.images as { id: number; file: File | string }[]) ?? []).map(async (img) => {
      if (typeof img.file === "string") {
        return img.file;
      }
      let compressed = await compressImage(img.file);
      compressed = compressed instanceof File ? compressed : new File([compressed], img.file.name);
      return compressed;
    }),
  );

  if (vehicleImages.length > 0) {
    const main_image = vehicleImages.splice(0, 1)[0];

    if (main_image instanceof File) {
      submittedData.append("main_image", main_image, main_image.name);
    } else if (typeof main_image === "string") {
      submittedData.append("main_image", main_image);
    }
  }

  // the value of the attribute before this step could be string | boolean
  // but we will send those data with form data so true should be "1"
  let attributes: { value: string; id: number }[] = [];

  Object.entries(data.attributes).forEach((attr: any) => {
    const oneAttribute = rawAttributes.find((el) => el.id === attr[0]);
    if (!oneAttribute) throw new Error("how did we set attribute value without having the attrbiute");
    if (attr[1] !== false && attr[1] !== "" && attr[1] !== "no_option") {
      attributes.push({
        id: +attr[0],
        value: insertValueIntoFormData(attr[1]),
      });
    }
  });

  let newAssignedAttributes: { id: number; value: string }[] = [];
  let deletedAttributes: { id: number; attribute_id: number }[] = [];
  let defaultAttributesIDS: {
    id: number;
    attribute_id: number;
    value: any;
  }[] = [];
  let defaultNotDeletedAttrs: {
    id: number;
    attribute_id: number;
    value: any;
  }[] = [];

  if (isEditing && defaultAttributes) {
    defaultAttributesIDS = [
      ...(defaultAttributes?.equipments?.map((attr: any) => ({
        id: attr.id,
        attribute_id: attr.id,
        value: attr.value,
      })) || []),
      ...(defaultAttributes?.highlights?.map((attr: any) => ({
        id: attr.id,
        attribute_id: attr.id,
        value: attr.value,
      })) || []),
    ];
    defaultAttributesIDS.forEach((attr) => {
      // if default(already configured attribute) doesn't exist on the current form data that means this attribute has been deleted
      const isDefaultStillExistInNewValues = attributes.findIndex(
        (el) => el.id.toString() === attr.attribute_id.toString(),
      );
      if (isDefaultStillExistInNewValues === -1) deletedAttributes.push({ ...attr });
    });

    defaultNotDeletedAttrs = defaultAttributesIDS
      .filter((attr) => deletedAttributes.findIndex((el) => el.id.toString() === attr.id.toString()) === -1)
      .map((attr) => ({
        id: attr.id,
        attribute_id: attr.attribute_id,
        value: attributes.find((el) => el.id.toString() === attr.attribute_id.toString())?.value,
      }));
    newAssignedAttributes = attributes.filter(
      (attr) => defaultAttributesIDS.findIndex((el) => el.attribute_id.toString() === attr.id.toString()) === -1,
    );
  }

  const extraSubmissions: Promise<AxiosResponse<any>>[] = [];

  if (isEditing && vehicleID) {
    if (vehicleImages?.length > 0) {
      extraSubmissions.push(uploadImagesToSellVehicle(vehicleType, +vehicleID, vehicleImages));
    }
    deletedImages
      .filter((i) => +i !== -1)
      .forEach((img) => {
        extraSubmissions.push(deleteImagesFromVehicle(vehicleType, +vehicleID, img));
      });
    deletedAttributes.forEach((attr) => {
      extraSubmissions.push(removeAttributesFomSellVehicle(vehicleType, +vehicleID, attr.id));
    });
    defaultNotDeletedAttrs.forEach((attr) => {
      extraSubmissions.push(updateAttributesToSellVehicle(vehicleType, +vehicleID, attr.id, attr.value));
    });
    if (newAssignedAttributes.length > 0)
      extraSubmissions.push(
        assignAttributesToSellVehicle(vehicleType, +vehicleID, {
          attributes: newAssignedAttributes,
        }),
      );

    try {
      const res = await Promise.all([updatedSoldVehicle(vehicleType, vehicleID, submittedData), ...extraSubmissions]);
      return res[0];
    } catch (error) {
      const err = error as AxiosError;
      // @ts-ignore
      const errorResponse = Object.values(error?.response?.data?.errors || {});
      throw new Error((errorResponse?.[0] as string) || "");
    }
  } else {
    try {
      const sellRes = await sellVehicle(vehicleType, submittedData);
      const vehicleID = sellRes.data.vehicle.id;
      if (attributes?.length > 0)
        extraSubmissions.push(
          assignAttributesToSellVehicle(vehicleType, +vehicleID, {
            attributes,
          }),
        );
      if (vehicleImages?.length > 0)
        extraSubmissions.push(uploadImagesToSellVehicle(vehicleType, +vehicleID, vehicleImages));
      const extraRes = await Promise.all([...extraSubmissions]);
      return sellRes;
    } catch (error) {
      const err = error as AxiosError;
      // @ts-ignore
      const errorResponse = Object.values(err?.response?.data?.errors || {});
      throw new Error((errorResponse?.[0] as string) || "");
    }
  }
};

// TODO: add type instead of any
export const vehicleCategoriesOptions = (categories: any) => {
  const categories0: SelectOption[] = [];
  const categories0DependantConditions: any[] = [
    // {
    //   name: "category_1",
    //   value: {
    //     no_option: "no_option",
    //   },
    // },
    {
      name: "category",
      value: {
        no_option: "no_option",
      },
    },
    {
      name: "brand",
      value: {
        no_option: "no_option",
      },
    },
    {
      name: "brand_model",
      value: {
        no_option: "no_option",
      },
    },
    {
      name: "model_id",
      value: {
        no_option: "no_option",
      },
    },
  ];
  // const categories1: SelectOption[] = [];
  // const categories1DependantConditions: any[] = [
  // {
  //   name: "category",
  //   value: {
  //     no_option: "no_option",
  //   },
  // },
  //   {
  //     name: "brand",
  //     value: {
  //       no_option: "no_option",
  //     },
  //   },
  //   {
  //     name: "brand_model",
  //     value: {
  //       no_option: "no_option",
  //     },
  //   },
  //   {
  //     name: "model_id",
  //     value: {
  //       no_option: "no_option",
  //     },
  //   },
  // ];
  const brands: SelectOption[] = [];
  const brandsDependantsConditions: any[] = [
    {
      name: "brand_model",
      value: {
        no_option: "no_option",
      },
    },
    {
      name: "model_id",
      value: {
        no_option: "no_option",
      },
    },
  ];
  const models: SelectOption[] = [];
  const modelsDependants: any[] = [
    {
      name: "model_id",
      value: {
        no_option: "no_option",
      },
    },
  ];
  const modelYears: SelectOption[] = [];
  const currentYear = new Date().getFullYear() + 1;
  Array(currentYear - 1970)
    .fill(0)
    .forEach((element, index) => {
      modelYears.push({
        label: (1970 + index).toString(),
        value: 1970 + index,
      });
    });
  modelYears.sort((a: any, b: any) => (+a.label < +b.label ? 1 : -1));
  let attributes: AttributesOption[] = [];

  categories.forEach((cat: any) => {
    if (cat.level === 0) {
      categories0.push({
        label: cat.name,
        value: cat.id.toString(),
        image: cat.icon,
      });
      categories0DependantConditions[0].value = Object.assign(categories0DependantConditions[0].value, {
        [cat.id]: "no_option",
      });
      categories0DependantConditions[1].value = Object.assign(categories0DependantConditions[1].value, {
        [cat.id]: "no_option",
      });
      categories0DependantConditions[2].value = Object.assign(categories0DependantConditions[2].value, {
        [cat.id]: "no_option",
      });
      categories0DependantConditions[3].value = Object.assign(categories0DependantConditions[3].value, {
        [cat.id]: "no_option",
      });

      // TODO: add type instead of any
      cat.brands.forEach((brand: any) => {
        const alreadyExistingIndex = brands.findIndex((el) => brand.id === +el.value);
        const currentCondition: RulesLogic = {
          or: [
            {
              "===": [{ var: "category_0" }, "no_option"],
            },

            {
              "==": [{ var: "category_0" }, cat.id.toString()],
            },
          ],
        };
        // brand could exist in multiple categories, so we need to check if it already exists, if it does, we need to update the rule for the existing brand instead  of adding new one
        if (alreadyExistingIndex === -1) {
          brands.push({
            label: brand.name,
            value: brand.id.toString(),
            dependsOn: {
              jsonLogic: true,
              /**
               * show all brands if no category_0 is selected
               * if category_0 is selected, show all brands of that category
               */
              rules: {
                or: [currentCondition],
              },
            },
          });
        } else {
          (brands[alreadyExistingIndex].dependsOn! as any).rules.or.push(currentCondition);
        }
        brandsDependantsConditions[0].value = Object.assign(brandsDependantsConditions[0].value, {
          [brand.id]: "no_option",
        });
        brandsDependantsConditions[1].value = Object.assign(brandsDependantsConditions[1].value, {
          [brand.id]: "no_option",
        });
      });
      // TODO: change type from any to the actual type
      cat.models.forEach((model: any) => {
        const alreadyExistingIndex = models.findIndex((el) => model.id === +el.value);

        if (alreadyExistingIndex === -1)
          models.push({
            label: model.name,
            value: model.id.toString(),
            // @ts-ignore
            brand_id: model.brand_id,
            dependsOn: {
              jsonLogic: true,
              /**
               * if category_0 is undefined, then filter based on brand_id
               * if category_0 is defined, then filter based on category_0 and brand_id
               */
              rules: {
                and: [
                  {
                    or: [
                      {
                        "===": [{ var: "category_0" }, "no_option"],
                      },

                      {
                        "===": [{ var: "category_0" }, cat.id.toString()],
                      },
                    ],
                  },
                  {
                    "==": [{ var: "brand" }, model.brand_id.toString()],
                  },
                ],
              },
            },
          });
      });
      cat.models.forEach((model: any) => {
        modelsDependants[0].value = Object.assign(modelsDependants[0].value, {
          [model.name]: "no_option",
        });
        // modelYears.push({
        //   label: model.year,
        //   value: model.id.toString(),
        //   dependsOn: [
        //     {
        //       name: "brand_model",
        //       value: model.name.toString(),
        //     },
        //     {
        //       name: "brand",
        //       value: model.brand_id.toString(),
        //     },
        //   ],
        // });
      });
      attributes.push(
        ...refactorAttributes(
          cat.attributes.map((attr: any) => {
            return {
              ...attr,
              parent: cat.id.toString(),
            };
          }),
          true,
        ),
      );
    }
    // if (cat.level === 1) {
    //   categories1.push({
    //     label: cat.name,
    //     value: cat.id.toString(),
    //     image: cat.icon,
    //     dependsOn: [
    //       {
    //         name: "category_0",
    //         value: cat.parent_id.toString(),
    //       },
    //     ],
    //   });
    //   categories1DependantConditions[0].value = Object.assign(categories1DependantConditions[0].value, {
    //     [cat.id]: "no_option",
    //   });
    //   categories1DependantConditions[1].value = Object.assign(categories1DependantConditions[1].value, {
    //     [cat.id]: "no_option",
    //   });
    //   categories1DependantConditions[2].value = Object.assign(categories1DependantConditions[2].value, {
    //     [cat.id]: "no_option",
    //   });
    // }
  });

  return {
    categories0,
    categories0DependantConditions,
    // categories1,
    // categories1DependantConditions,
    brands,
    brandsDependantsConditions,
    models,
    modelsDependants,
    modelYears,
    attributes,
  };
};
